export default __webpack_public_path__ + "static/media/right-top-vinho2.91050d62.png";